import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Icon } from 'shared/components/index';

import theme from './DeleteIcon.scss';

const propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  mediaResized: PropTypes.bool,

  handleClick: PropTypes.func.isRequired,
  clearSelection: PropTypes.func.isRequired,
};

const defaultProps = {
  size: 'small',
  mediaResized: false,
};

const DeleteIcon = ({ intl, size, mediaResized, handleClick, clearSelection }) => {
  const handleDeleteIconClick = (e) => {
    handleClick(e);
    clearSelection();
  };

  return (
    <Icon
      name="circle-x-fill"
      className={ classnames(theme.deleteIcon, {
        [theme[size]]: size,
        [theme.mediaResized]: mediaResized,
      }, theme.deleteIcon) }
      onClick={ handleDeleteIconClick }
      aria-label={ intl.formatMessage({ id: 'GeneralInputField.ClearButton.TilteAttribute', defaultMessage: '** Clear input' }) }
    />
  );
};

DeleteIcon.propTypes = propTypes;
DeleteIcon.defaultProps = defaultProps;

export default DeleteIcon;
